import { Actions, FeatureFlagState } from 'modules/featureFlags/types';
import { formatAction } from 'modules/featureFlags/utils';
import styled from 'styled-components';
import { FormField } from 'ui/formField';
import { InputText } from 'ui/inputs';
import { Body2, spacing } from 'ui/theme';
import { ConfirmationBanner } from './ConfirmationBanner';
import { ConfirmationCard } from './ConfirmationCard';

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.double};
`;

const Message = styled(Body2)`
  margin-bottom: 0;
`;

/**
 * Confirmation Modal
 */
type ConfirmationModalProps = {
  confirmation: string;
  currentState: FeatureFlagState;
  env: string;
  flagName: string;
  handleChangeConfirmation: (val: string) => void;
  updatedState: FeatureFlagState;
};

export const ConfirmationModalBody = ({
  confirmation,
  currentState,
  env,
  flagName,
  handleChangeConfirmation,
  updatedState,
}: ConfirmationModalProps) => {
  const action = formatAction(currentState.enabledGlobally, updatedState.enabledGlobally);

  return (
    <Body>
      <Message>
        You are about to change feature availability for <b>{flagName}</b>. Review the following
        details before saving.
      </Message>

      <ConfirmationBanner
        action={action}
        globalFraction={updatedState.globalFraction}
        isFractional={currentState.isFractional}
        orgIdFractions={updatedState.orgIdFractions}
        projectIdFractions={updatedState.projectIdFractions}
      />

      <ConfirmationCard
        action={action}
        currentOrgIds={currentState.enabledOrgIds}
        updatedOrgIds={updatedState.enabledOrgIds}
        currentProjects={currentState.enabledProjectIds}
        updatedProjects={updatedState.enabledProjectIds}
        variant={Actions.Enabled}
      />

      <ConfirmationCard
        action={action}
        currentOrgIds={currentState.disabledOrgIds}
        updatedOrgIds={updatedState.disabledOrgIds}
        currentProjects={currentState.disabledProjectIds}
        updatedProjects={updatedState.disabledProjectIds}
        variant={Actions.Disabled}
      />

      <FormField labelText={`Please type in '${env}' to confirm these changes`}>
        <InputText
          data-test="confirmation-input"
          onChange={handleChangeConfirmation}
          placeholder={env}
          value={confirmation}
        />
      </FormField>
    </Body>
  );
};
